/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    var module = this;

    module.sliderSettingsObject = {
        global: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 1,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            preventInteractionOnTransition: true
        },

        section: {
            simulateTouch: false,
            keyboard: {
                enabled: false
            },
            slidesPerView: 1,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            preventInteractionOnTransition: true,
            allowTouchMove: false,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            customButtonActive: undefined,
            customButtons: [],
            on: {
                init: function () {
                    var swiper = this;
                    var sourcesTextEls = document.querySelectorAll(".sources__text");
                    var sourcesHeights;

                    var calculateMaxHeight = function () {
                        sourcesHeights = [];

                        Array.prototype.forEach.call(sourcesTextEls, function (sourcesText) {
                            sourcesHeights.push(sourcesText.offsetHeight);
                        });

                        var maxHeight = Math.max(...sourcesHeights);

                        Array.prototype.forEach.call(sourcesTextEls, function (sourcesText) {
                            sourcesText.style.height = maxHeight + "px";
                        });
                    }

                    calculateMaxHeight();

                    itsoftApp.modules.windowResize.addEvent(function () {
                        Array.prototype.forEach.call(sourcesTextEls, function (sourcesText) {
                            sourcesText.style.height = "";
                        });
                        calculateMaxHeight();
                    });

                    this.params.customButtonActive = this.$el[0].closest(".js-slider").querySelector(".js-custom-button.js-active");
                    this.params.customButtons = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-button");
                    var links = document.querySelectorAll(".js-custom-button");
                    Array.prototype.forEach.call(links, function (link, index) {
                        link.addEventListener("click", function (evt) {
                            evt.preventDefault();
                            swiper.slideTo(+index);
                        })
                    })
                },

                slideChangeTransitionStart: function () {
                    var swiper = this;
                    Array.prototype.forEach.call(itsoftApp.modules.slidersLibrary.sliders.sources, function (source) {
                        source.slideTo(0);
                    });

                    var activeIndex = this.activeIndex;
                    this.params.customButtonActive.classList.remove("js-active");
                    this.params.customButtonActive.parentNode.classList.remove("js-active");
                    this.params.customButtonActive = this.params.customButtons[activeIndex];
                    this.params.customButtonActive.classList.add("js-active");
                    this.params.customButtonActive.parentNode.classList.add("js-active");
                }
            }
        },

        sources: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            // centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            preventInteractionOnTransition: true,
            nested: true,
            spaceBetween: 20,
            breakpoints: {
                744: {
                    centeredSlides: false,
                    slidesPerView: 3
                }
            },
            on: {
                init: function () {
                    itsoftApp.modules.slidersLibrary.sliders.sources.push(this);
                }
            }
            // rewind: true
        },

        cards: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 1,
            followFinger: false,
            watchOverflow: true,
            spaceBetween: 32,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            preventInteractionOnTransition: true,
            breakpoints: {
                744: {
                    slidesPerView: 2
                }
            }
        },

        products: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            spaceBetween: 24,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            preventInteractionOnTransition: true,
            breakpoints: {
                744: {
                    slidesPerView: 2
                },

                1024: {
                    spaceBetween: 40,
                    slidesPerView: 3
                }
            }
        },

        stories: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: true,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            freeModeMomentum: false,
            preventInteractionOnTransition: true,
            on: {
                init: function () {
                    var swiper = this;
                    var slides = swiper.slides;

                    var storiesGallerySliderTrigger = document.querySelector(".js-stories-trigger");
                    var storiesGallerySliderContainer = storiesGallerySliderTrigger.querySelector(".swiper-container");
                    var storiesGallerySliderId = storiesGallerySliderContainer.id;

                    var sliderSettingsKey = storiesGallerySliderTrigger.getAttribute("data-slider-settings"); // получаем data-атрибут
                    var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига
                    
                    if (sliderSettingsKey && sliderSettingsObject) {
                        itsoftApp.modules.slidersLibrary.callback(storiesGallerySliderTrigger, sliderSettingsObject[sliderSettingsKey]);
                    } else {
                        itsoftApp.modules.slidersLibrary.callback(storiesGallerySliderTrigger);
                    }

                    /* ----------- */

                    Array.prototype.forEach.call(slides, function (slide, index) {
                        var slideLink = slide.querySelector(".js-gallery-item");

                        slideLink.addEventListener("click", function (evt) {
                            evt.preventDefault();

                            if (index == itsoftApp.modules.slidersLibrary.sliders[storiesGallerySliderId].activeIndex) {
                                itsoftApp.modules.slidersLibrary.sliders[storiesGallerySliderId].emit("slideChange");
                            }

                            itsoftApp.modules.slidersLibrary.sliders[storiesGallerySliderId].slideTo(index);

                            // var gallerySlider = itsoftApp.modules.slidersLibrary.sliders["storiesGallery"];
                            // var activeIndex = gallerySlider.activeIndex;
                        });
                    });
                }
            }
        },

        storiesGallery: { /* Галерея внутри модалки */
            // simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            centeredSlides: true,
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            slideToClickedSlide: true,
            _autoplayDelay: 3000,
            on: {
                init: function () {
                    var swiper = this;
                    var gallerySlider = swiper;
                    itsoftApp.modules.slidersLibrary.sliders[swiper.el.id] = swiper;
                    var slides = swiper.slides;

                    Array.prototype.forEach.call(slides, function (slide, slideIndex) {
                        slide.setAttribute("data-id", slideIndex);
                    });

                    var activeIndex = swiper.activeIndex;
                    var previousIndex;

                    swiper.on("slideChange", function () {
                        previousIndex = swiper.previousIndex;
                        activeIndex = swiper.activeIndex;
                        var subSliderPrev = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + previousIndex];
                        var subSliderActive = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + activeIndex];
                        // subSliderPrev.params.autoplay = false;
                        if (subSliderPrev && subSliderPrev !== "") {
                            subSliderPrev.autoplay.stop();
                        }
                        if (subSliderPrev && subSliderPrev.params.slideTimeout) {
                            clearTimeout(subSliderPrev.params.slideTimeout);
                            subSliderPrev.slideTo(0);
                            // subSliderPrev.autoplay.stop();
                            subSliderPrev.params.slideTimeout = null;
                        }
                        subSliderActive.params.autoplay.delay = gallerySlider.params._autoplayDelay;
                        subSliderActive.params.autoplay.disableOnInteraction = false;
                        subSliderActive.autoplay.start();

                        if (subSliderActive.slides.length <= 1) {
                            subSliderActive.params.slideTimeout = setTimeout(function () {
                                if (gallerySlider.slides.length - 1 != gallerySlider.activeIndex) {
                                    gallerySlider.slideNext();
                                }
                            }, gallerySlider.params._autoplayDelay);
                        }
                    });

                    swiper.on("orientationchange", function () {
                        swiper.update();
                    });

                    // swiper.on("update", function () {
                    //     var activeIndex = swiper.activeIndex;
                    //     var subSliderActive = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + activeIndex];
                    //     subSliderActive.autoplay.stop();
                    // });
                }
            },
            speed: 500
        },

        storiesMore: {
            // simulateTouch: false,
            keyboard: {
                enabled: false
            },
            // autoplay: {
            //     disableOnInteraction: false,
            //     // stopOnLastSlide: true
            // },
            slideToClickedSlide: true,
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            allowTouchMove: false,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            nested: true,
            on: {
                init: function () {
                    var swiper = this;
                    var el = swiper.el;
                    var elParent = el.closest(".js-slider");
                    var sliderIndex = elParent.getAttribute("data-id");
                    itsoftApp.modules.slidersLibrary.sliders["storiesMore" + sliderIndex] = swiper;
                    var gallerySlider = itsoftApp.modules.slidersLibrary.sliders["storiesGallery"];
                    swiper.params.slideTimeout = null;

                    if (gallerySlider.activeIndex == sliderIndex) {
                        swiper.params.autoplay.delay = gallerySlider.params._autoplayDelay;
                        swiper.params.autoplay.disableOnInteraction = false;
                        swiper.autoplay.start();

                        if (swiper.slides.length <= 1) {
                            swiper.params.slideTimeout = setTimeout(function () {
                                if (gallerySlider.slides.length - 1 != gallerySlider.activeIndex) {
                                    gallerySlider.slideNext();
                                }
                            }, gallerySlider.params._autoplayDelay);
                        }
                    } else {
                        // swiper.params.autoplay = false;
                        swiper.autoplay.stop();
                    }

                    var swiperTrigger = swiper.el.closest(".js-slider");

                    swiper.on("slideChange", function () {
                        if (swiper.params.slideTimeout) {
                            clearTimeout(swiper.params.slideTimeout);
                            swiper.params.slideTimeout = null;
                        }

                        if (swiper.slides.length - 1 == swiper.activeIndex) {
                            // swiper.params.autoplay = false;
                            swiper.autoplay.stop();

                            swiper.params.slideTimeout = setTimeout(function () {
                                if (gallerySlider.slides.length - 1 != gallerySlider.activeIndex) {
                                    gallerySlider.slideNext();
                                }
                            }, gallerySlider.params._autoplayDelay);
                        } else if (!swiper.autoplay.running && gallerySlider.activeIndex == sliderIndex) {
                            swiper.params.autoplay.delay = gallerySlider.params._autoplayDelay;
                            swiper.params.autoplay.disableOnInteraction = false;
                            swiper.autoplay.start();
                        }
                    });

                    swiper.on("orientationchange", function () {
                        setTimeout(function () {
                            swiper.update();
                        }, 1000);
                    });

                    // var progressEnded = function () {
                    //     swiper.slideNext();
                    //     progressBar.style.animation = "none";
                    //     void progressBar.offsetWidth; // Triggers Reflow
                    //     progressBar.style.animation = null;
                    // }

                    // var progressBar = swiperTrigger.querySelector(".nav__progress");
                    // progressBar.addEventListener("animationend", progressEnded);

                    // swiper.on("slideChange", function () {
                    //     progressBar.style.animation = "none";
                    //     void progressBar.offsetWidth; // Triggers Reflow
                    //     progressBar.style.animation = null;
                    //     progressBar.style.animationPlayState = "paused";
                    // });
                }
            },
            speed: 500 
        }
    };
});